const {h, render, Component} = require('preact');

class TicketCreationButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onSubmitClick();
  }

  render() {
    return (
      <div class="t-field">
        <p class="create-refund-btn">
          <a href="" class="submit-button btn refund-btn" disabled id="createTicket" onClick={this.handleClick} data-bhw="web2018-refund-form-submit">
            {I18n.translate('js.modules.support.confirm_refund_request')} </a>
        </p>
      </div>
    )
  }
}

module.exports = TicketCreationButton